
import { getCurrentInstance, defineComponent, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import Header from "@/layouts/home/Header.vue";
import Footer from "@/layouts/home/Footer.vue";
import SideBar from "@/layouts/home/SideBar.vue";

export default defineComponent({
  setup() {
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const store = useStore();
    const router = useRouter();

    router.beforeEach((to)=>{
      document.title = 'Xarcade Developer: '+ to.meta.title;
    });

    const testnetLabel = computed(() => {
      return store.getters['config/configTestnetLabel'];
    });

    // sidebar handler for mobile view - less than screen of md
    // in mobile view - xs/sm - always hide menu drop down whenever screen is resized less than md width
    const isMobileView = () => {
      // more than md
      if(window.innerWidth >= 900){
        // trigger always show sideMenu by default
        store.dispatch('config/setDropDown', true);
      }else{
        // trigger always hide menu by default
        store.dispatch('config/setDropDown', false);
      }
    }

    const screenResizeHandler = () => {
      isMobileView();
    };
    screenResizeHandler();

    onUnmounted(() => {
      window.removeEventListener("resize", screenResizeHandler);
    });

    onMounted(() => {
      window.addEventListener("resize", screenResizeHandler);
    });

    const pageClick = () => {
      emitter.emit("PAGE_CLICK");
    }


    return {
      store,
      testnetLabel,
      pageClick,
    };
  },
  name: "App",
  components: {
    Header,
    SideBar,
    Footer,
  },
  mounted() {
    sessionStorage.setItem("createdGame", "0");
  },
});
